import { useLocation, useNavigationType } from '@remix-run/react'
import { useEffect } from 'react'

export function useCloudflareAnalytics() {
	const location = useLocation()
	const navigationType = useNavigationType()

	useEffect(() => {
		// only track soft navigations (not initial load)
		if (navigationType !== 'POP') {
			// @ts-ignore: cloudflare analytics beacon
			if (window.cf_beacon && typeof window.cf_beacon.onPageView === 'function') {
                // @ts-ignore: cloudflare analytics beacon
				window.cf_beacon.onPageView()
			}
		}
	}, [location.pathname, navigationType])
}
